import React, { ReactChild, ReactChildren } from "react";
import { classNames } from "../utils";

export type BadgeColors =
  | ("red" | "blue" | "yellow" | "purple" | "gray" | "default")
  | string;

function colorClassByBadgeColor(color: BadgeColors = "green") {
  switch (color) {
    case "yellow":
      return "bg-yellow-100 text-yellow-800";
    case "red":
      return "bg-red-100 text-red-800";
    case "blue":
      return "bg-blue-100 text-blue-800";
    case "purple":
      return "bg-purple-100 text-purple-800";
    case "gray":
      return "bg-gray-100 text-black";
    default:
      return "bg-green-100 text-green-800";
  }
}

function colorDotClassByBadgeColor(color: BadgeColors = "green") {
  switch (color) {
    case "yellow":
      return "bg-yellow-400";
    case "red":
      return "bg-red-400";
    case "blue":
      return "bg-blue-400";
    case "gray":
      return "bg-gray-400";
    default:
      return "bg-green-400";
  }
}

export type BadgeProps = {
  children: ReactChild | ReactChildren;
  color?: BadgeColors | undefined;
  hasDot?: boolean;
  className?: string;
  title?: string;
};

const Badge = ({
  children,
  color,
  hasDot = true,
  className,
  title,
}: BadgeProps) => {
  const badgeColorClass: string = colorClassByBadgeColor(color);
  const dotColorClass: string = colorDotClassByBadgeColor(color);
  return (
    <div
      className={classNames(
        "inline-flex justify-center items-center",
        "pt-0.5 pb-0.5 pr-2.5 pl-2 rounded-xl font-semibold",
        className ? className : badgeColorClass
      )}
      title={title ?? ""}
    >
      {hasDot && (
        <span
          className={`block w-2 h-2 rounded-full mr-1 ${dotColorClass}`}
        ></span>
      )}
      {children}
    </div>
  );
};

export default Badge;
